import ApiCaller from '../ApiCaller';
import baseAjaxConfig from '../BaseAjaxConfig';
export var MOVE_TO_WISHLIST_FROM_CART;
(function (MOVE_TO_WISHLIST_FROM_CART) {
    MOVE_TO_WISHLIST_FROM_CART["REQUEST"] = "MOVE_TO_WISHLIST_FROM_CART_REQUEST";
    MOVE_TO_WISHLIST_FROM_CART["SUCCESS"] = "MOVE_TO_WISHLIST_FROM_CART_SUCCESS";
    MOVE_TO_WISHLIST_FROM_CART["ERROR"] = "MOVE_TO_WISHLIST_FROM_CART_ERROR";
})(MOVE_TO_WISHLIST_FROM_CART || (MOVE_TO_WISHLIST_FROM_CART = {}));
export function moveToWishListAction(listingIds = []) {
    if (!listingIds.length) {
        return Promise.reject('');
    }
    return (dispatch) => {
        dispatch({
            type: MOVE_TO_WISHLIST_FROM_CART.REQUEST
        });
        return ApiCaller.delete(Object.assign({}, baseAjaxConfig, {
            pathname: '/api/5/cart',
            action: MOVE_TO_WISHLIST_FROM_CART.REQUEST,
            query: {
                listingIds: listingIds.join(','),
                dest: 'wishlist'
            }
        }))
            .then(data => {
            dispatch({
                type: MOVE_TO_WISHLIST_FROM_CART.SUCCESS,
                data: data.RESPONSE
            });
            return data;
        })
            .catch(err => {
            dispatch({
                type: MOVE_TO_WISHLIST_FROM_CART.ERROR,
                error: err
            });
            return Promise.reject(err);
        });
    };
}
